import { useEffect, useState } from 'react';

import { Box, Container, Heading } from '@brand/components';

import { CategoryEntity, CategoryTradeType, Tree } from '@domain/entities';

import { Category } from '@hoa/config';

import { PrismicRichText } from '@hoa/atoms';
import { SubCategories } from '@hoa/organisms';

import { useTrade, useTranslation } from '@hoa/hooks';

import { PrismicSliceType } from '@domain/types';
import { LocalStorage } from '@hoa/config';
import { useRouter } from 'next/router';

interface Props {
  tree: Tree | undefined;
  details?: PrismicSliceType;
}

export const CategorySubCategories = (props: Props): JSX.Element => {
  const { trade } = useTrade();
  const { locale, t } = useTranslation();
  const router = useRouter();
  const [searchQuery, setSearchQuery] = useState<any>('');

  const subCategories =
    props.tree?.children.find(
      child => child.id === Category[trade as CategoryTradeType],
    )?.children || [];

  const onClick = (value: string | number | CategoryEntity[] | undefined) => {
    setSearchQuery(value);
  };

  useEffect(() => {
    const translateServiceRequest = t(`common:generic.serviceRequest`);
    const categoryUrl = router.query.trade;

    if (router.isReady && searchQuery !== '' && categoryUrl !== undefined) {
      localStorage.setItem(LocalStorage.SR_SAVED_STEP, '2');
      router.push({
        pathname: `/${locale}/${categoryUrl}/${translateServiceRequest}/`,
        query: { type: searchQuery },
      });
    }
  }, [searchQuery]);

  return (
    <Box as="section" bg="gray.50" py={10}>
      <Container textAlign="center">
        <Heading as="h2" variant="h3" textAlign="center" mb={10}>
          {props.details?.primary.title}
        </Heading>
        <PrismicRichText
          render={props.details?.primary.sub_categories_description}
        />
        <SubCategories
          subCategories={subCategories}
          onSubCategoryClick={onClick}
        />
      </Container>
    </Box>
  );
};
